<template>
  <!-- Modal -->
  <div
    class="modal fade"
    id="cookiesDialog"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLongTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Cookies</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body"><p>
          Používáním tohoto webu souhlasíte s používáním cookies. Cookies na tomto webu jsou používány pouze k následujícím účelům.
          <ul>
            <li>Zajištění funkčnosti stránek</li>
            <li>Sledování návštěvnosti pomocí google analytics</li>
          </ul>

          Cookies na této stránce nejsou předávány třetím stranám za účelem marketingu.
        </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Gdpr",
};
</script>